import { useTranslation } from "react-i18next"
import { Button, Flex } from "@chakra-ui/react"

import { useRecoilValue } from "recoil"
import { viewSelector } from "../../../../recoil/atoms/view"
import { Views } from "../../../../constants"
import { AuthPageStyling } from "src/context/types"

type AvatarCardHoverOverlayProps = {
  branding: AuthPageStyling
  openShow: () => void
  openShowInNewTab: () => void
  isRoomloading: boolean
  isCurrentRoomLoading: boolean
  btnText: string
}

export const AvatarCardHoverOverlay = ({
  branding,
  openShow,
  openShowInNewTab,
  isRoomloading,
  isCurrentRoomLoading,
  btnText
}: AvatarCardHoverOverlayProps) => {
  const { t } = useTranslation()
  const view = useRecoilValue(viewSelector)

  return (
    <Flex
      width="full"
      height="full"
      backgroundColor="rgba(51,51,51,0.8)"
      justify="center"
      align="center"
      userSelect="none"
      direction="column"
    >
      <Button
        isLoading={isCurrentRoomLoading}
        disabled={isRoomloading}
        loadingText={t("Joining...")}
        bg={branding?.authPageButtonBackgroundColor ?? "#1AC541"}
        border={
          branding?.authPageButtonBorderColor
            ? `1px solid ${
                branding?.authPageButtonBorderColor
                  ? branding.authPageButtonBorderColor
                  : "transparent"
              }`
            : "0px"
        }
        textColor={branding?.authPageButtonTextColor ?? "#FFFFFF"}
        _hover={{
          backgroundColor:
            branding?.authPageButtonMouseoverBackgroundColor ?? "#24A840",
          textColor: branding?.authPageButtonMouseoverTextColor ?? "#FFFFFF"
        }}
        _disabled={{ opacity: 0.38 }}
        width="156px"
        _focus={{}}
        _active={{}}
        onClick={openShow}
      >
        {t(btnText)}
      </Button>

      {view === Views.MEETING_ROOM && (
        <Button
          bg={branding?.authPageButtonBackgroundColor ?? "#1AC541"}
          border={
            branding?.authPageButtonBorderColor
              ? `1px solid ${
                  branding?.authPageButtonBorderColor
                    ? branding.authPageButtonBorderColor
                    : "transparent"
                }`
              : "0px"
          }
          textColor={branding?.authPageButtonTextColor ?? "#FFFFFF"}
          _hover={{
            backgroundColor:
              branding?.authPageButtonMouseoverBackgroundColor ?? "#24A840",
            textColor: branding?.authPageButtonMouseoverTextColor ?? "#FFFFFF"
          }}
          width="156px"
          _focus={{}}
          _active={{}}
          onClick={openShowInNewTab}
          margin={2}
          _disabled={{ opacity: 0.38 }}
          disabled={isRoomloading}
        >
          {t("Watch in new tab")}
        </Button>
      )}
    </Flex>
  )
}

